import { modalSet, nextModalSet } from "_slices/view";
import { useRouter, useSearchParams, usePathname } from 'next/navigation'
import { useEffect, useState } from "react";
import miscEvent from 'lib/ga/miscEvent';
import styles from './title.module.css';
import globalStyles from '../result.module.css';

interface Props {
  id: number;
  isLDC: boolean;
  isLoggedIn: boolean;
  stuck: boolean;
  headerHeight: number;
  mainTitle: string;
  dispatch: any;
  addressText: string;
  showAllAgentContacts: boolean;
  setShowAllAgentContacts: any;
  agents: any;
  type: string;
  showPage: boolean;
}

const TitleDisplay = ({ stuck, isLDC, headerHeight, addressText, id, mainTitle, isLoggedIn, dispatch, agents, setShowAllAgentContacts, showAllAgentContacts, type, showPage }: Props) => {
  const router = useRouter();
  const query = useSearchParams();
  const pathName = usePathname();

  let [showBackButton, setShowBackButton] = useState(false);
  useEffect(() => {
    if (document.referrer) {
      const domain = (new URL(document.referrer))
      setShowBackButton(domain.origin === process.env.NEXT_PUBLIC_APP_URL)
    }
  });
  const hasContacts = agents.filter(value => value.users.length > 0);
  let hasContactWithNumbers = false;

  for (const item in hasContacts) {
    for (const user in hasContacts[item].users) {
      const hasNumber = hasContacts[item].users[user].contacts.filter(value => value.number)
      if (hasNumber.length > 0) {
        hasContactWithNumbers = true;
        break;
      }
    }
  }
  return (
    <div className={`${styles.TitleContainer} ${stuck && !isLDC ? styles.stuck : ''}`} style={stuck && !isLDC ? { top: headerHeight + "px" } : {}}
    >
      {showBackButton && (
        <button className={`${styles.backButton} ${styles.contactButton}`} onClick={() => router.back()}>Back</button>
      )}
      <div className={styles.titleWrapper}>

        <h1 className={styles.titleContent}>
          <span className={globalStyles.titleText}>{mainTitle} </span>
          <span className={`${globalStyles.largeText} ${globalStyles.lightColorText}`}>
            {addressText}
          </span>


        </h1>
        <div className={styles.contactContent}>
          {(!isLDC && agents.length > 0 && showPage) && <>

            {hasContacts.length > 0 &&
              <button className={`${styles.contactButton} ${styles.marginRight}`}
                id="property-contact"
                onClick={(e) => {
                  const log = {
                    event: 'show_all_agent_contacts',
                    result_id: id,
                    subject_type: type
                  }
                  miscEvent(log)

                  const element = document.getElementById("agent-contain");
                  element?.scrollIntoView({ behavior: "smooth", block: "end", inline: "start" })
                  setShowAllAgentContacts(true)
                }}
              >
                {hasContactWithNumbers ? ' Call Agents' : 'Show agents'}
              </button>
            }

            <button className={`${styles.contactButton} ${styles.marginRight}`}
              id="property-contact"
              onClick={(e) => {
                if (isLoggedIn) {
                  dispatch(
                    modalSet({
                      visible: true,
                      type: "contactProperty",
                      view: id.toString(),
                      router: router,
                    })
                  );
                } else {
                  dispatch(
                    modalSet({
                      visible: true,
                      type: "auth",
                      view: "login",
                      router: router,
                    })
                  );
                  dispatch(
                    nextModalSet({
                      visible: true,
                      type: "contactProperty",
                      view: id.toString(),
                      router: router,
                      query: query,
                      asPath: pathName
                    })
                  );
                }
              }}
            >
              Email Agents
            </button>

          </>}

        </div>
      </div>
    </div>
  );
}

export default TitleDisplay;